module.exports = __webpack_public_path__ + "img/logo-blanco-lineas.d493f56c.png";